import { Sites } from '@ps/platform-message-framework/common/Sites';
import { StarsButton, Translation } from '@ps/web-shared-components';
import React from 'react';
import { Field } from 'react-final-form';
import { useSelector } from 'react-redux';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardLoading from '@swf/core/hooks/useWizardLoading';
import { select } from '@swf/core/store';

import Container from '../../../../../Container/Container';

import LimitsSelectButton from './Buttons/LimitsSelectButton';
import {
  TXTMOB_Set_deposit_limits,
  TXTMOB_We_offer_a_range_of_tools_to_h_ELL,
  TXTWCL_Continue,
  TXTWCL_Continue_to_deposit,
  TXTWCL_Responsible_gaming
} from './RMFDepositLimitsIntroduction.messages.json';
import { h3 } from './RMFDepositLimitsIntroduction.scss';

interface Props {
  setDepositLimits?: () => void;
}

const RMFDepositLimitsIntroduction: React.FC<Props> = ({ setDepositLimits }) => {
  const { values } = useWizardContext();
  const { loading } = useWizardLoading();

  const isCAON = useSelector(select.cms.getSiteId) === Sites.CA_ON;

  return (
    <Container
      page={RMFDepositLimitsIntroduction}
      headerProps={{
        title: <Translation {...TXTWCL_Responsible_gaming} />,
        showSGImage: true,
        buttons: { back: values.sumSubVerification?.pased !== true }
      }}
    >
      <h2>{<Translation {...TXTWCL_Responsible_gaming} />}</h2>
      <h3 className={h3}>
        <Translation {...TXTMOB_We_offer_a_range_of_tools_to_h_ELL} />
      </h3>
      <ButtonGroup>
        <Field name="userLimitsSelect">
          {({ input: { onChange } }) => (
            <>
              <LimitsSelectButton
                variant="primary"
                loading={loading}
                translation={isCAON ? TXTWCL_Continue_to_deposit : TXTWCL_Continue}
                onClick={() => onChange({ skipped: true })}
              />
              <StarsButton
                variant="secondary"
                loading={loading}
                translation={TXTMOB_Set_deposit_limits}
                target="#rmf.rmf-deposit-limit"
                onClick={setDepositLimits}
              />
            </>
          )}
        </Field>
      </ButtonGroup>
    </Container>
  );
};

RMFDepositLimitsIntroduction.displayName = 'RMFDepositLimitsIntroduction';

export default RMFDepositLimitsIntroduction;
